import React from 'react';

import type { RouteContext } from '@atlassian/jira-router';
import {
	LastOpenedConfigTab,
	boardSettingsQueryConfigParamValues,
} from '@atlassian/jira-software-board-settings-rapidboard-config-common';
import RapidBoardCardColoursSettings from '@atlassian/jira-spa-apps-classic-board-settings-card-colours';
import RapidBoardCardLayoutSettings from '@atlassian/jira-spa-apps-classic-board-settings-card-layout';
import RapidBoardColumnsSettings from '@atlassian/jira-spa-apps-classic-board-settings-columns';
import RapidBoardEstimationSettings from '@atlassian/jira-spa-apps-classic-board-settings-estimation';
import RapidBoardGeneralSettings from '@atlassian/jira-spa-apps-classic-board-settings-general';
import RapidBoardQuickFiltersSettings from '@atlassian/jira-spa-apps-classic-board-settings-quick-filters';
import RapidBoardSwimlanesSettings from '@atlassian/jira-spa-apps-classic-board-settings-swimlanes';
import RapidBoardTimelinesSettings from '@atlassian/jira-spa-apps-classic-board-settings-timeline';
import RapidBoardWorkingDaysSettings from '@atlassian/jira-spa-apps-classic-board-settings-working-days';

export const BoardConfigSwitcher = (props: RouteContext) => {
	const { query } = props;

	switch (query.config) {
		case boardSettingsQueryConfigParamValues.general:
			return <RapidBoardGeneralSettings />;
		case boardSettingsQueryConfigParamValues.columns:
			return <RapidBoardColumnsSettings />;
		case boardSettingsQueryConfigParamValues.swimlanes:
			return <RapidBoardSwimlanesSettings />;
		case boardSettingsQueryConfigParamValues.quickFilters:
			return <RapidBoardQuickFiltersSettings />;
		case boardSettingsQueryConfigParamValues.cardColors:
			return <RapidBoardCardColoursSettings />;
		case boardSettingsQueryConfigParamValues.cardLayout:
			return <RapidBoardCardLayoutSettings />;
		case boardSettingsQueryConfigParamValues.estimation:
			return <RapidBoardEstimationSettings />;
		case boardSettingsQueryConfigParamValues.workingDays:
			return <RapidBoardWorkingDaysSettings />;
		case boardSettingsQueryConfigParamValues.timeline:
			return <RapidBoardTimelinesSettings />;
		default:
			return <LastOpenedConfigTab configParam={query.config} />;
	}
};
